import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'

import { api } from '@/lib/api'

export function useTokens() {
  return useQuery({
    queryKey: ['tokens'],
    queryFn: () => api.tokens.list(),
    select: (res) => res.data,
  })
}

export function useCreateToken() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (body: { name: string; scope?: string[] }) => api.tokens.create(body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['tokens'] }),
  })
}

export function useDeleteToken() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => api.tokens.delete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['tokens'] }),
  })
}
